export default "__VITE_ASSET__C6eN1Smo__"